



















































































































































































import { Component, Vue, Watch } from "vue-property-decorator"
import { mapState } from "vuex"
import { BOOKING_PURPOSES } from "@/constants/booking"

@Component({
  computed: {
    ...mapState("Auth", {
      user: "user"
    }),
    ...mapState("BookingCandidate", {
      bookingCandidate: "bookingCandidate"
    })
  }
})
export default class BookingCandidateReadPolicy extends Vue {
  // bookingCandidate State
  bookingCandidate!: BookingCandidate
  user!: Model

  isLoading = false
  consent: number[] = []
  isAgree = false
  additionalServices = ""
  lastScrollTop = 0
  currentStep = 0
  isRead: number[] = []

  bookingPurposes = BOOKING_PURPOSES

  @Watch("consent")
  watchLoading(v) {
    let arr = [0, 1, 2, 3, 4]
    if (
      this.bookingCandidate.booking.purpose ===
      this.bookingPurposes.PURPOSE_HEALTH_CHECK_FOR_CURRENT_EMPLOYEE.key
    ) {
      arr = [0, 1, 2, 3]
    }
    this.isAgree = arr.every(i => v.includes(i))
  }

  get title() {
    return (
      "Welcome, <span class='secondary--text'>" + this.user.name + "</span>"
    )
  }

  confirm() {
    this.isLoading = true
    this.$store
      .dispatch(
        "BookingCandidate/confirmPolicy",
        this.$route.params.bookingCandidateOid
      )
      .then(() => {
        this.$store
          .dispatch(
            "BookingCandidate/startQuestionnaire",
            this.$route.params.bookingCandidateOid
          )
          .then(() => {
            this.$store
              .dispatch(
                "BookingCandidate/fetch",
                this.$route.params.bookingCandidateOid
              )
              .then(() => {
                this.$router.push({
                  name: "candidate-start-selected-questionnaire",
                  params: {
                    beOid: this.$route.params.bookingCandidateOid
                  }
                })
                this.isLoading = false
              })
          })
      })
  }

  async beforeMount() {
    await this.$store
      .dispatch("Document/fetch", "additional-services")
      .then(response => {
        this.additionalServices = response.data.data
      })
  }

  gotoSelectedVendor(target) {
    this.$vuetify.goTo(target, {
      container: this.$refs.stepper as Vue
    })
  }

  toDocuments(slug) {
    this.$router.push({
      name: slug
    })
  }
}
